module.exports = __webpack_public_path__ + "static/media/dog6.7024daba.jpeg";